// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  firebaseConfig : {
    apiKey: "AIzaSyDMgf0HMCqB5YxuLNbtvOArn7e2qbnJeeE",
    authDomain: "angularstudy-a2077.firebaseapp.com",
    projectId: "angularstudy-a2077",
    storageBucket: "angularstudy-a2077.appspot.com",
    messagingSenderId: "182322147640",
    appId: "1:182322147640:web:d3ceacb5f134cc2a8911cd",
    measurementId: "G-C4ZKPQ99HM"
  },

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
